module.exports = __webpack_public_path__ + "7317be16d79e6fafe7901c73954a019d.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/winking-12.png
// module id = 2277
// module chunks = 0